import { Link } from "react-router-dom";
import { MessageCircle, Instagram } from "lucide-react";
import { waDisplay, INSTAGRAM_HANDLE, INSTAGRAM_URL, waPlain } from "@/lib/whatsapp";

const LINKS = [
  { label: "Início", to: "/", id: "footer-inicio" },
  { label: "Bonés", to: "/catalogo", id: "footer-bones" },
  { label: "Bonés Importados", to: "/importados", id: "footer-importados" },
  { label: "Marcas", to: "/#marcas", id: "footer-marcas" },
  { label: "Instagram", to: INSTAGRAM_URL, id: "footer-instagram", external: true },
  { label: "WhatsApp", to: waPlain(), id: "footer-whatsapp", external: true },
];

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-graphite">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <p className="font-display text-2xl font-extrabold tracking-[0.15em]">DM IMPORTS</p>
          <p className="mt-4 text-sm leading-relaxed text-zinc-400">
            Bonés | Roupas premium
            <br />
            Importados e Nacionais
          </p>
          <p className="mt-4 text-xs uppercase tracking-[0.25em] text-zinc-500">
            +1.000 clientes atendidos
          </p>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-zinc-500">Navegação</p>
          <ul className="mt-5 space-y-3">
            {LINKS.map((link) => (
              <li key={link.id}>
                {link.external ? (
                  <a href={link.to} target="_blank" rel="noopener noreferrer" data-testid={link.id} className="text-sm text-zinc-400 transition-colors hover:text-offwhite">
                    {link.label}
                  </a>
                ) : (
                  <Link to={link.to} data-testid={link.id} className="text-sm text-zinc-400 transition-colors hover:text-offwhite">
                    {link.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-zinc-500">Contato</p>
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-handle" className="mt-5 flex items-center gap-3 text-sm text-zinc-400 transition-colors hover:text-offwhite">
            <Instagram className="h-4 w-4" /> {INSTAGRAM_HANDLE}
          </a>
          <a href={waPlain()} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-number" className="mt-3 flex items-center gap-3 text-sm text-zinc-400 transition-colors hover:text-offwhite">
            <MessageCircle className="h-4 w-4" /> {waDisplay()}
          </a>
          <a
            href={waPlain()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-button"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-offwhite px-6 py-3 text-[11px] font-bold uppercase tracking-[0.2em] text-obsidian transition-transform duration-300 hover:scale-[1.03]"
          >
            <MessageCircle className="h-4 w-4" />
            Chamar no WhatsApp
          </a>
        </div>
      </div>

      <div className="mt-14 border-t border-white/10 pt-6 text-center">
        <p data-testid="footer-copyright" className="text-xs text-zinc-500">
          © 2026 DM Imports. Todos os direitos reservados.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
